import { setFallbackTitle } from './fallback-title.util';
import { applySimplePageSeo } from './seo-strategy.helpers';
import { SeoStrategyFn } from './seo-strategy.type';

/**
 * SEO strategy for the home page
 * Falls back to 'default' template if 'home' is not present
 */
export const HomeSeoStrategy: SeoStrategyFn = (seoContent, $document, cacheContent) => {
  // Check for 'home' template first, fallback to 'default'
  const seoKey = seoContent['home'] ? 'home' : 'default';

  if (!seoContent[seoKey]) {
    setFallbackTitle(cacheContent, $document);
    return;
  }

  // Use the helper which includes schema generation
  applySimplePageSeo(seoKey, 'home', '/', seoContent, $document, cacheContent);
};
